import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=da85d4ec&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=da85d4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da85d4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da85d4ec')) {
      api.createRecord('da85d4ec', component.options)
    } else {
      api.reload('da85d4ec', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=da85d4ec&scoped=true&", function () {
      api.rerender('da85d4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Qwtv0T70tC/JS/comp/DocBox.vue"
export default component.exports